import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { Box, Text } from '@mantine/core';
import { memo } from 'react';

interface Props {
	title: string;
	value: string;
}

const BankingDetailsCard = (props: Props) => {
	const { title, value } = props;
	return (
		<Box
			sx={{
				display: 'flex',
				padding: '0.5rem',
				alignItems: 'flex-start',
				gap: '0.5rem',
				alignSelf: 'stretch',
				borderRadius: '0.25rem',
				border: `1px solid ${defaultTheme.v3.colors.gray[4]}`,
				background: `${defaultTheme.v3.colors.gray[0]}`,
				flexDirection: 'column',
			}}
		>
			<Text size="B6Bold">{title}</Text>
			<Text size="B6Medium">{value}</Text>
		</Box>
	);
};
const _BankingDetailsCardExport = memo(BankingDetailsCard);

export { _BankingDetailsCardExport as BankingDetailsCard };
